<script lang="ts">
	import VerifiedUser from '$lib/icons/verifiedUser.svelte';
	import StarRating from '$lib/review/starRating.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import type { VerifiedReview } from '$lib/storyblok/types';

	interface Props {
		review: VerifiedReview;
		showAvatar: boolean;
	}

	let { review, showAvatar = false }: Props = $props();
</script>

<div class="flex flex-col rounded-2xl bg-brown-6 p-6 text-brown-1 lg:p-8 lg:pb-6">
	<div>
		<StarRating starClass="h-6 w-6" score={review.score} />

		<p
			class="mt-6 flex -translate-x-[6px] text-[24px]/[108%] tracking-[-.24px] lg:text-[32px]/[110%] lg:tracking-[-.32px]"
		>
			<span>“</span>
			<span>
				{review.title}”
			</span>
		</p>

		<p class="mt-4 text-[14px]/[160%] lg:text-[16px]/[150%]">{review.content}</p>
	</div>

	<div class="mt-6 flex items-center gap-x-2 border-t border-brown-5 pt-2">
		{#if showAvatar}
			<div
				class="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full text-brown-1"
				class:bg-orange-4={!review.avatar?.filename}
			>
				{#if review.avatar?.filename}
					<Image
						class="h-full w-full object-cover"
						src={review.avatar.filename}
						alt={review.avatar.alt}
						title={review.avatar.title}
						height={50}
						width={50}
					/>
				{:else}
					{review.name.charAt(0)}
				{/if}
			</div>
		{/if}
		<div>
			<p class="text-[12px]/[160%] lg:text-[14px]/[160%]">
				{review.name}<span class:hidden={!review.city}>,</span>
				{#if review.city}
					<span class="text-brown-4">
						{review.city}
					</span>
				{/if}
			</p>
			{#if review.verified}
				<p class="-mt-0.5 text-[12px] text-green-3">
					Verified buyer <VerifiedUser class="inline-block h-4 w-4" />
				</p>
			{/if}
		</div>
	</div>
</div>
